<script setup lang="ts">
import IKImageS3Wrapper from '@/imagekit/IKImageS3Wrapper.vue'
import OpensInNewTabIcon from '@/components/OpensInNewTabIcon.vue'
import WikiText from '@/components/wikitext/WikiText.vue'
import { truncateTextWithEllipsis } from '@/util/strings'
import { toolkitUrls } from '@/util/links'
import type { StrategySummary } from '@/strategies/strategy_types'

type ReferencedStrategy = Pick<StrategySummary, 'uuid' | 'slug' | 'title' | 'description' | 'image_url'>

defineProps<{ strategies: ReferencedStrategy[] }>()

const DESCRIPTION_MAX_LENGTH = 140

const shortDescription = (strategy: ReferencedStrategy) => truncateTextWithEllipsis(strategy.description, DESCRIPTION_MAX_LENGTH)
</script>

<template>
  <ul class="m-0 list-none p-0">
    <li v-for="strategy in strategies" :key="strategy.uuid" class="mt-4 flex first:mt-0" data-testid="strategy-media-item">
      <div class="shrink-0 pr-2.5">
        <IKImageS3Wrapper
          v-if="strategy.image_url"
          :aws-url="strategy.image_url"
          alt=""
          :transformation="[{ w: 64, q: 80 }]"
          class="w-fit rounded-xs border border-gray-400 bg-white p-1"
        />
      </div>
      <div class="min-w-0">
        <h3 class="mb-1 mt-0 text-text-xl font-medium leading-5">
          <a
            :href="toolkitUrls.strategyPage(strategy.slug)"
            target="_blank"
            class="text-blue-400 hover:text-blue-500 hover:underline"
          >
            {{ strategy.title }} <OpensInNewTabIcon />
          </a>
        </h3>
        <WikiText :text="shortDescription(strategy)" plaintext class="text-md" />
      </div>
    </li>
  </ul>
</template>
